// Blog: September 2026 developer introduction and Poppy in Twitch Chat launch.
import { BRAND_LINKS } from '../../../configs/brandLinks';
import { defineDocument, link, list, p, section, strong, text, } from '../../schema';
export const blogPoppyHasEnteredTheChatDocument = defineDocument({
    id: 'blog:poppy-has-entered-the-chat',
    kind: 'blog',
    slug: 'poppy-has-entered-the-chat',
    route: '/blog/poppy-has-entered-the-chat',
    seo: {
        title: 'Poppy Has Entered the Chat',
        description: 'Poppy can now interact in your Twitch chat to help you host. Plus, meet the human behind Airhead Games.',
        imageAsset: 'blogPitc',
        imageAlt: 'Poppy posting an Airhead Games join link in a Twitch chat',
    },
    hero: {
        eyebrow: [text('Airhead Blog')],
        title: [text('Poppy Has Entered the Chat')],
        description: [
            text('Poppy can now interact in your Twitch chat to help you host. Plus, meet the human behind Airhead Games.'),
        ],
        imageAsset: 'blogPitc',
        imageAlt: 'Poppy posting an Airhead Games join link in a Twitch chat',
        showDescription: true,
        background: 'blurred-image',
    },
    meta: {
        author: 'Jay',
        publishedAt: new Date('2026-09-24T00:00:00.000Z'),
        tags: ['news', 'features'],
    },
    sections: [
        section({
            id: 'article',
            blocks: [
                p([
                    text('Poppy hosts your games. Starting today, Poppy can hop into your Twitch chat too. But Poppy is not a person. I am, and this post is about both of us.'),
                ]),
            ],
            sections: [
                section({
                    id: 'article__a-real-person-on-the-other-side',
                    title: 'A Real Person on the Other Side',
                    blocks: [
                        p([
                            text("The world of AI looks very different from when I started building Airhead Games. I've been a big believer in AI for a long time, and I still am. AI is super useful in many ways, but an assault on the senses in others. The way it has taken over social networks feels like the enshittification of the internet, and I don't want Airhead Games to be mistaken for another mindless AI slop cannon."),
                        ]),
                        p([
                            text('Airhead Games uses AI with purpose. Each game in our suite leverages AI in some way to enhance the human experience, not replace it. Your creativity and humor remain the most important parts.'),
                        ]),
                        p([
                            text("I build products for people to enjoy together, and you deserve to know there is a real person on the other side of the screen, supporting you and your community. After a few years of hiding behind Poppy, I'm ready to dox myself. It should always be clear what is AI and what is not."),
                        ]),
                        p([
                            text("So, who am I? My name is Jay. I enjoy playing basketball, hiking, and scuba diving, and I'm the solo developer behind Airhead Games as well as a few other projects. All of my projects share a common goal: help people find joy along this journey we call life."),
                        ]),
                        p([
                            text(`Poppy will remain the mascot for Airhead Games, and Poppy's content will be AI-generated or part of an automation. When I author content or interact with you, it will be clearly labeled as "Jay", and you can be certain it's coming from a human.`),
                        ]),
                    ],
                }),
                section({
                    id: 'article__poppy-has-entered-the-chat',
                    title: 'Poppy Has Entered the Chat',
                    blocks: [
                        p([
                            text("After watching a lot of streams, I've seen two common patterns: streamers manually drop the join link in chat, and they tell viewers about the game they are playing. Now I've deepened our integration with Twitch, so Poppy can do both of those things for you directly in your chat."),
                        ]),
                        p([
                            text('Open '),
                            link('/library?section=poppy-chat', 'Poppy in Twitch Chat'),
                            text(' in the Library and turn on either feature:'),
                        ]),
                        list({
                            items: [
                                [
                                    strong('Auto-post room join link'),
                                    text(': Poppy posts the join link in your chat each time you open a new room.'),
                                ],
                                [
                                    strong('Respond to commands'),
                                    text(': viewers type a command and Poppy answers. For example, '),
                                    strong('!airhead game'),
                                    text(' explains the game you are playing. The feature starts with '),
                                    link('/discover/features/moderator-tools#poppy-in-twitch-chat', 'just a few commands'),
                                    text(' and will expand over time.'),
                                ],
                            ],
                        }),
                        {
                            type: 'image',
                            imageAsset: 'featurePitcChat',
                            imageAlt: 'Twitch chat where Poppy posts a room join link and replies to a viewer command',
                            caption: [
                                {
                                    type: 'text',
                                    text: 'Poppy shares the join link and responds to commands in Twitch chat.',
                                },
                            ],
                        },
                    ],
                }),
                section({
                    id: 'article__poppy-in-discord',
                    title: 'Poppy in Discord',
                    blocks: [
                        p([
                            text('Beyond Twitch, I changed how Poppy interacts in Discord. First and foremost, "Jay" will take over as the primary communicator for Airhead Games, and the Poppy profile will be for automated messages. Additionally, I fixed some bugs with the '),
                            link('/discover/features/twitch#going-live', 'Going Live'),
                            text(' announcements.'),
                        ]),
                        p([
                            text('Stop by the '),
                            link(BRAND_LINKS.discord, 'Discord'),
                            text(" to say hi! It's the best way to get support, give feedback, and connect with me and the community."),
                        ]),
                    ],
                }),
            ],
        }),
    ],
});
//# sourceMappingURL=poppy-has-entered-the-chat.js.map